import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=11eebff0&"
import script from "./reviews.vue?vue&type=script&lang=js&"
export * from "./reviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11eebff0')) {
      api.createRecord('11eebff0', component.options)
    } else {
      api.reload('11eebff0', component.options)
    }
    module.hot.accept("./reviews.vue?vue&type=template&id=11eebff0&", function () {
      api.rerender('11eebff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Heading/reviews.vue"
export default component.exports